import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'

const MyChips = ({ user, settings }) => {

    const history = useNavigate()
    const [isLoading, setIsLoading] = useState(true)
    const [shouldRedirect, setShouldRedirect] = useState(false)

    useEffect(() => {
        // Wait for both user and settings to be actually loaded (not null/undefined)
        if (user && settings !== null && settings !== undefined) {
            setIsLoading(false)
            
            if (!settings.mychips || !user) {
                setShouldRedirect(true)
                return
            }
        }
    }, [user, settings])

    useEffect(() => {
        if (shouldRedirect) {
            history('/')
            return
        }
    }, [shouldRedirect, history])

    useEffect(() => {
        // Only run script logic when we have valid data
        if (isLoading || shouldRedirect || !user?.offer_id || !settings?.mychips) {
            return
        }

        const script = document.createElement('script');
        script.src = 'https://v1.mychips.io/SDK/latest/my-chips-sdk.bundle.js';
        script.async = true;

        script.onload = () => {
            if (window.myChipsSDK && user?.offer_id) {
                window.myChipsSDK('init', { userId: user.offer_id });
            }
        };

        document.head.appendChild(script);

        return () => {
            const existingScript = document.querySelector('script[src="https://v1.mychips.io/SDK/latest/my-chips-sdk.bundle.js"]');
            if (existingScript) {
                document.head.removeChild(existingScript);
            }
        };
    }, [isLoading, shouldRedirect, user?.offer_id, settings?.mychips]);

    if (isLoading) {
        return <div>Loading...</div>
    }

    if (shouldRedirect) {
        return null;
    }

    return (

        <>
            <div className="wall-container">
                <iframe
                    id='my-chips-iframe'
                    allow='ch-ua-platform; ch-ua-platform-version'
                    src={`https://sdk.mychips.io/content?content_id=ccfd7392-d27e-403a-881a-4d4972b06291&user_id=${user.offer_id}`}
                />
            </div>

            <style jsx>{`
                .wall-container {
                    width: 100%;
                    height: 100%;
                }
                iframe {
                    width: 100%;
                    height: 100%;
                    border: none;
                    border-radius: 8px;
                    margin-top: 20px;
                }
            `}</style>
        </>

    );

};

export default MyChips;